import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_ADDITIONAL_INCOME } from "../../action-types/actions";

import i18n from "../../i18n";
export const getAdditionalIncomeSummary = createAsyncThunk(
  ACTIONS_ADDITIONAL_INCOME.get_summary,
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.additionalIncomeSummary}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorFetchingIncomeSummary");
      return rejectWithValue(errMsg);
    }
  },
);

export const getAdditionalIncomeActivities = createAsyncThunk(
  ACTIONS_ADDITIONAL_INCOME.get_activities,
  async (
    { page = 1, limit = 20, service_type = "all" } = {},
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        service_type,
      });

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.additionalIncomeActivities}?${queryParams.toString()}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorFetchingIncomeActivities");
      return rejectWithValue(errMsg);
    }
  },
);
